import React, { useEffect, useState, useCallback } from "react";
import { usePlaidLink } from "react-plaid-link";
import {getVerificationLinkToken, updateManualVerification} from "../../api";

type Props = {
    history: {
        push: Function,
    },
}

const PlaidVerificationPage = (props: Props) => {
    const { match: { params: { referenceGid } } } = props;
    const [linkToken, setLinkToken] = useState(null);
    const [status, setStatus] = useState("initializing");
    // "initializing", "verifying", "success", "error"

    // 1. Fetch link_token from your backend
    useEffect(() => {
        async function fetchToken() {
            try {
                const entity = await getVerificationLinkToken(referenceGid);
                setLinkToken(entity?.token);
            } catch (err) {
                console.error("Error fetching link token", err);
                setStatus("error");
            }
        }
        fetchToken();
    }, []);

    // 2. Callback when Plaid verification finishes successfully
    const onSuccess = useCallback((public_token, metadata) => {
        console.log("Verification success:", metadata);
        setStatus("success");
        // You can POST metadata to backend for record-keeping
        async function updateSuccessStatus() {
            try {
                await updateManualVerification(metadata?.account_id);
            } catch (err) {
                console.error("Error fetching link token", err);
                setStatus("error");
            }
        }
        updateSuccessStatus();
    }, []);

    // 3. Callback if user exits
    const onExit = useCallback((err, metadata) => {
        console.log("Plaid exited:", err, metadata);
        setStatus("error");
    }, []);

    const config = {
        token: linkToken,
        onSuccess,
        onExit,
        onEvent: (eventName, metadata) => {
            console.log("Plaid Event:", eventName, metadata);
        }
    };

    const { open, ready } = usePlaidLink(config);

    // 4. Auto-open Plaid when ready
    useEffect(() => {
        if (ready && linkToken) {
            setStatus("verifying");
            open();
        }
    }, [ready, linkToken, open]);

    return (
        <div style={{ padding: "2rem", textAlign: "center", fontFamily: "sans-serif" }}>
            {status === "initializing" && <p>Preparing verification, please wait…</p>}
            {status === "verifying" && <p>Opening secure verification…</p>}
            {status === "success" && <p style={{ color: "green" }}>✅ Verification complete!</p>}
            {status === "error" && <p style={{ color: "red" }}>❌ Verification failed. Please try again.</p>}
        </div>
    );
}

export default PlaidVerificationPage;
